import template from './userDetails.html';
import controller from './userDetails.controller';
import './userDetails.scss';

const userDetailsComponent = {
  bindings: {
    user: '<',
  },
  template,
  controller,
};

export default userDetailsComponent;



// WEBPACK FOOTER //
// ./client/app/components/user/userDetails/userDetails.component.js